import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRedoLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.966 3.96967C12.6731 4.26257 12.6732 4.73744 12.966 5.03033L15.6857 7.75H12.5184C6.58007 7.75 3.53549 14.8653 7.63565 19.1608L8.45388 20.0179C8.73989 20.3175 9.21464 20.3285 9.51425 20.0425C9.81386 19.7565 9.82489 19.2817 9.53887 18.9821L8.72069 18.125C8.72069 18.125 8.7207 18.1251 8.72069 18.125C5.53169 14.7841 7.89969 9.25 12.5184 9.25H15.6857L12.966 11.9697C12.6732 12.2626 12.6731 12.7374 12.966 13.0303C13.2589 13.3232 13.7338 13.3232 14.0267 13.0303L18.0267 9.03033C18.1674 8.88968 18.2464 8.69891 18.2464 8.5C18.2464 8.30109 18.1674 8.11032 18.0267 7.96967L14.0267 3.96967C13.7338 3.67678 13.2589 3.67678 12.966 3.96967Z",
		fill: "currentColor"
	})
});
export default SvgRedoLine;
